import AuthAPI from "../../../../api/auth";
import { getTokenLocal } from "../../../../helper/utils";
import { useResponseHandle } from "../../../hooks";
import PermissionsTable from "./PermissionsTable";

const authAPI = new AuthAPI()


export const addModulePermission = async (allModules: any, currentModule: any, role: any, token: string) => {
    let tempArr: any = [];

    currentModule.permissions.forEach((perm: any) => {
        tempArr.push({ "role_id": role, "permission_id": perm?.id })
    })

    const response = await authAPI?.assignPermission(token, tempArr);

    const result = useResponseHandle({ apiResponse: response, successMessage: true })

    if (result?.isAuthorized) {
        let tempModules: any = [];

        allModules.forEach((module: any) => {

            let tempModule = { ...module };


            if (module?.module_name == currentModule?.module_name) {
                let tempPermissions: any = [];

                module.permissions.forEach((perm: any) => {
                    let newPerm = {};
                    newPerm = { ...perm, is_assigned: true }
                    tempPermissions.push({ ...newPerm })
                })
                tempModule.permissions = tempPermissions;
                tempModule.is_assigned = true;


                tempModules.push({ ...tempModule });
            } else {
                tempModules.push({ ...module });
            }
        })

        return { tempModules: tempModules, ...result };
    } else {
        return result;
    }

}

export const removeModulePermission = async (allModules: any, currentModule: any, role: any, token: string) => {
    let tempArr: any = [];

    currentModule.permissions.forEach((perm: any) => {
        tempArr.push({ "role_id": role, "permission_id": perm?.id })
    })

    if (token) {
        const response = await authAPI?.removePermission(token, tempArr);

        const result = useResponseHandle({ apiResponse: response, successMessage: true })

        if (result?.isAuthorized) {
            let tempModules: any = [];

            allModules.forEach((module: any) => {

                let tempModule = { ...module };


                if (module?.module_name == currentModule?.module_name) {
                    let tempPermissions: any = [];

                    module.permissions.forEach((perm: any) => {
                        let newPerm = {};
                        newPerm = { ...perm, is_assigned: false }
                        tempPermissions.push({ ...newPerm })
                    })
                    tempModule.permissions = tempPermissions;
                    tempModule.is_assigned = false;
                    tempModule.indeterminate = false;


                    tempModules.push({ ...tempModule });
                } else {
                    tempModules.push({ ...module });
                }
            })

            return { tempModules: tempModules, ...result };
        } else {
            return result;
        }
    }

}

export const addPermission = async (allModules: any, moduleName: any, role: any, permId: any, token: string) => {

    if (token) {
        const response = await authAPI?.assignPermission(token, [{ role_id: role, permission_id: permId }]);

        const result = useResponseHandle({ apiResponse: response, successMessage: true })

        if (result?.isAuthorized) {
            let tempModules: any = [];

            allModules.forEach((module: any) => {

                let tempModule = { ...module };


                if (module?.module_name == moduleName) {
                    let tempPermissions: any = [];
                    let flag = true;
                    module.permissions.forEach((perm: any) => {


                        if (perm?.id == permId) {
                            let newPerm = {};
                            newPerm = { ...perm, is_assigned: true }
                            tempPermissions.push(newPerm);
                        } else {
                            if (perm.is_assigned == false) {
                                flag = false;
                            }
                            tempPermissions.push(perm);
                        }
                    })
                    tempModule.permissions = tempPermissions;
                    tempModule.indeterminate = true;

                    if (flag) {
                        tempModule.is_assigned = true;
                    }


                    tempModules.push({ ...tempModule });
                } else {
                    tempModules.push({ ...module });
                }
            })

            return { tempModules: tempModules, ...result };

        } else {
            return result;
        }
    }

}

export const removePermission = async (allModules: any, moduleName: any, role: any, permId: any, token: string) => {

    if (token) {
        const response = await authAPI?.removePermission(token, [{ role_id: role, permission_id: permId }]);

        const result = useResponseHandle({ apiResponse: response, successMessage: true })

        if (result?.isAuthorized) {
            let tempModules: any = [];

            allModules.forEach((module: any) => {

                let tempModule = { ...module };


                if (module?.module_name == moduleName) {
                    let tempPermissions: any = [];
                    module.permissions.forEach((perm: any) => {
                        if (perm?.id == permId) {
                            let newPerm = {};
                            newPerm = { ...perm, is_assigned: false }
                            tempPermissions.push(newPerm);
                        } else {
                            tempPermissions.push(perm);
                        }
                    })
                    tempModule.permissions = tempPermissions;
                    tempModule.is_assigned = false;

                    tempModules.push({ ...tempModule });
                } else {
                    tempModules.push({ ...module });
                }
            })

            return { tempModules: tempModules, ...result };

        } else {
            return result;
        }
    }

}

export { PermissionsTable };